export default {
  general: require('./general.json'),
  compass: require('./compass.json'),
  components: require('./components.json'),
  sharing: require('./sharing.json'),
  tracker: require('./tracker.json'),
}
